import React, {
    useState, useEffect, useRef, useMemo
} from 'react';
import PropTypes from 'prop-types';
import move from 'lodash-move';
import defaultStyles from './ColumnSelector.module.scss';
import View from './ColumnSelectorView';

const ColumnSelector = (props) => {
    const [columns, setColumns] = useState(props.columns);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [hidingUnselected, setHidingUnselected] = useState(false);
    const wrapperRef = useRef(null);

    const handleClickOutside = (event) => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        setColumns(props.columns);
    }, [props.columns]);

    useEffect(() => () => {
        document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        setColumns(columns.filter((column) => !column.draggable).concat(move(
            columns.filter((column) => column.draggable),
            result.source.index,
            result.destination.index
        )));
    };

    const setColumnVisibility = (row, checked) => {
        setColumns(columns.map((column) => (column.id === row.id && column.hideable ? {
            ...column, visible: checked
        } : column)));
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const submitInfo = () => {
        props.applyFilter(columns);
        setDropdownOpen(false);
    };

    const columnsToRender = useMemo(() => {
        if (!hidingUnselected) {
            return columns;
        }
        return columns.filter((column) => column.visible);
    }, [hidingUnselected, columns]);

    return (
        <div ref={ wrapperRef }>
            <View
                setColumnVisibility={ setColumnVisibility }
                columnsToRender={ columnsToRender }
                dropdownOpen={ dropdownOpen }
                hidingUnselected={ hidingUnselected }
                onDragEnd={ onDragEnd }
                setHidingUnselected={ setHidingUnselected }
                styles={ props.styles }
                submitInfo={ submitInfo }
                toggleDropdown={ toggleDropdown }
            />
        </div>
    );
};

ColumnSelector.propTypes = {
    applyFilter: PropTypes.func,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string,
            type: PropTypes.string
        })
    ),
    styles: PropTypes.objectOf(PropTypes.string),
};

ColumnSelector.defaultProps = {
    applyFilter: () => { },
    columns: [],
    styles: defaultStyles,
};

export { defaultStyles };
export default ColumnSelector;
